const DEFAULT_IMAGE_PROXY_TEMPLATE =
  'https://wsrv.nl/?url={encodedUrl}&w={width}&q={quality}&fit=cover&output=webp';

const REMOTE_IMAGE_RE = /^https?:\/\//i;

function fillTemplate(template: string, rawUrl: string, width: number, quality: number) {
  return template
    .replaceAll('{url}', rawUrl)
    .replaceAll('{encodedUrl}', encodeURIComponent(rawUrl))
    .replaceAll('{width}', String(width))
    .replaceAll('{quality}', String(quality));
}

export function buildOptimizedImageUrl(rawUrl: string, width: number, quality = 75) {
  if (!REMOTE_IMAGE_RE.test(rawUrl)) return rawUrl;

  const template = import.meta.env.VITE_IMAGE_PROXY_TEMPLATE?.trim() || DEFAULT_IMAGE_PROXY_TEMPLATE;
  return fillTemplate(template, rawUrl, width, quality);
}

interface ResponsiveImageOptions {
  widths: number[];
  sizes: string;
  quality?: number;
  fallbackWidth?: number;
}

export function getResponsiveImageProps(rawUrl: string | null | undefined, options: ResponsiveImageOptions) {
  if (!rawUrl) return null;

  const widths = [...new Set(options.widths.filter((width) => width > 0))].sort((a, b) => a - b);
  if (widths.length === 0) {
    return {
      src: rawUrl,
      srcSet: undefined,
      sizes: options.sizes,
    };
  }

  const quality = options.quality ?? 75;
  const fallbackWidth = options.fallbackWidth && widths.includes(options.fallbackWidth)
    ? options.fallbackWidth
    : widths[Math.min(1, widths.length - 1)];

  return {
    src: buildOptimizedImageUrl(rawUrl, fallbackWidth, quality),
    srcSet: widths.map((width) => `${buildOptimizedImageUrl(rawUrl, width, quality)} ${width}w`).join(', '),
    sizes: options.sizes,
  };
}